import React, { useState } from "react";
import { ButtonsSection, CustomButton } from './sponsorStylingForm'

interface widgetProps { sponsorData: any, type: string, handleSave: Function, handleDelete: Function, handleCancel: Function }
export default function ButtonsArea(props: widgetProps) {
    let { sponsorData, type, handleSave, handleDelete, handleCancel } = props;
    return (
        <ButtonsSection type={props.type}>
            <CustomButton option={1} onClick={() => { handleSave() }} disabled={sponsorData.Launched}>
                Save
            </CustomButton>

            {type !== "edit" ? '' : (
                <CustomButton option={2} onClick={() => { handleDelete() }} disabled={sponsorData.Launched}>
                    Delete
                </CustomButton>
            )}

            <CustomButton option={2} onClick={() => { handleCancel() }}>
                Cancel
            </CustomButton>
        </ButtonsSection>
    );
}